import { render, staticRenderFns } from "./FollowupV7.vue?vue&type=template&id=d0361d9c&scoped=true"
import script from "./FollowupV7.vue?vue&type=script&lang=js"
export * from "./FollowupV7.vue?vue&type=script&lang=js"
import style0 from "./FollowupV7.vue?vue&type=style&index=0&id=d0361d9c&prod&lang=scss"
import style1 from "./FollowupV7.vue?vue&type=style&index=1&id=d0361d9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0361d9c",
  null
  
)

export default component.exports